module.exports = __webpack_public_path__ + "img/illu_delete_playlist.d087d071.png";